export default __webpack_public_path__ + "static/media/Ballroll_00262.afa990b7.png";